<script setup lang="ts" generic="MM">
import FormField from '@/components/input/FormField.vue'
import RichTextField from '@/components/input/RichTextField.vue'
import { Validation, ValidationArgs } from '@vuelidate/core'
import { useAttrs } from 'vue'

const props = defineProps<{
  modelValue?: string
  label: string
  validation?: Validation<ValidationArgs, MM>
  markdown?: boolean
  hint?: string
}>()
const emit = defineEmits<{
  'update:modelValue': [value: string]
  blur: []
}>()

const attrs = useAttrs()

function onBlur() {
  props.validation?.$touch
  emit('blur')
}
</script>

<template>
  <form-field :label="props.label" :validation="props.validation" :hint="props.hint">
    <rich-text-field
      v-if="props.markdown"
      :model-value="props.modelValue"
      :disabled="!!attrs.disabled"
      @update:model-value="(val) => $emit('update:modelValue', val)"
      @blur="onBlur"
    />
    <v-textarea
      v-else
      v-bind="$attrs"
      :model-value="props.modelValue"
      hide-details
      auto-grow
      @update:model-value="(val) => $emit('update:modelValue', val)"
      @blur="onBlur"
    />
  </form-field>
</template>
